/**
 * Phase 14.8 — SEO-Konstanten für die Marketing-Page. Eigenes Modul, damit der
 * Component-File {@code MarketingHead.tsx} ausschließlich Komponenten exportiert
 * (sonst meckert react-refresh/only-export-components).
 */
export const MARKETING_TITLE = 'Dispatch24 — Die moderne Leitstellen-Simulation';
export const MARKETING_DESCRIPTION =
  'Echtzeit-Leitstelle für Feuerwehr, Rettungsdienst und Polizei. Spiele in echten Städten in DACH. Kostenlos im Browser.';
export const MARKETING_CANONICAL = 'https://dispatch24.example/';
export const MARKETING_OG_IMAGE = '/marketing/hero-map.png';

export interface MetaSpec {
  /** Either "name" or "property" attribute. */
  attr: 'name' | 'property';
  key: string;
  value: string;
}

export const MARKETING_META_TAGS: MetaSpec[] = [
  { attr: 'name', key: 'description', value: MARKETING_DESCRIPTION },
  { attr: 'property', key: 'og:type', value: 'website' },
  { attr: 'property', key: 'og:title', value: MARKETING_TITLE },
  { attr: 'property', key: 'og:description', value: MARKETING_DESCRIPTION },
  { attr: 'property', key: 'og:image', value: MARKETING_OG_IMAGE },
  { attr: 'property', key: 'og:url', value: MARKETING_CANONICAL },
  { attr: 'name', key: 'twitter:card', value: 'summary_large_image' },
  { attr: 'name', key: 'twitter:title', value: MARKETING_TITLE },
  { attr: 'name', key: 'twitter:description', value: MARKETING_DESCRIPTION },
  { attr: 'name', key: 'twitter:image', value: MARKETING_OG_IMAGE },
];

export const MARKETING_STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@type': 'WebApplication',
  name: 'Dispatch24',
  description: MARKETING_DESCRIPTION,
  url: MARKETING_CANONICAL,
  applicationCategory: 'GameApplication',
  operatingSystem: 'Web Browser',
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'EUR',
  },
  inLanguage: 'de',
} as const;
